export default function LegalNotices() {
  return (
    <div className="privacy-maincard">
      <div style={{ padding: "20px" }}>
        <div className="privacy-maintitle">
          <h1>Legal Notices</h1>
          <p>
            Review the legal terms and conditions governing the use of
            LEGITIMATELY's services.
          </p>
          <div className="privacy_cards">
            <div className="privacy_title">
              <h2>Intellectual Property</h2>
              <p>
                All content on LEGITIMATELY is protected under copyright laws.
              </p>
            </div>
            <div className="privacy_title">
              <h2>Disclaimer</h2>
              <p>
                We strive for accuracy but cannot guarantee the completeness of
                all information on LEGITIMATELY.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
